// this is an autogenerated file from DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/Phones/Content/Phone/Related/Content/Popup/Content/Persons/Person/Relation/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomRelationshipsItem_Edit_NonPatient_Phone_Phones_Content_Phone_Related_Content_Popup_Content_Persons_Person_Relation($from_person_id: numeric!, $to_person_id: numeric!) {
  vaxiom_relationships(
    where: {
      from_person: { _eq: $from_person_id }
      to_person: { _eq: $to_person_id }
    }
  ) {
    id
    type
  }
}

`